import InspectionSuccess from "./InspectionSuccess.container";
export default InspectionSuccess;